export const urlEncoder = {
    methods: {
        encode: (string) => {
            return encodeURI(
                btoa(btoa(string)).replace(/=/g, '')
            );
        },
        decode: (string) => {
            if (!string) return string;
            const decoded = atob(atob(decodeURI(string)));
            return decoded;
        },
    },
};
